import React, { useState, useEffect } from 'react';
import styles from './loading.module.css';

export default () => {
  return (
    <div style={{ width: '100vw', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
      <div className={styles.loading}></div>
    </div>
  );
};
